module.exports = __webpack_public_path__ + "img/notice.81f53656.png";